export default __webpack_public_path__ + "static/Verlag-BoldItalic-8e111777ff7e17da936e282dd4d7ae99.woff2";